"use client";

import React from "react";
import { GoogleGeminiEffect } from "./google-gemini-effect";
import { CircleGrid } from "./circle-grid";
import { Plus } from "geist-icons";
import { useScroll, useTransform } from "framer-motion";

export default function FirstParallaxHome() {
  const ref = React.useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["end end", "end start"],
  });

  const pathLengthFirst = useTransform(scrollYProgress, [0, 0.8], [0.2, 1.2]);
  const pathLengthSecond = useTransform(scrollYProgress, [0, 0.8], [0.15, 1.2]);
  const pathLengthThird = useTransform(scrollYProgress, [0, 0.8], [0.1, 1.2]);
  const pathLengthFourth = useTransform(scrollYProgress, [0, 0.8], [0.05, 1.2]);
  const pathLengthFifth = useTransform(scrollYProgress, [0, 0.8], [0, 1.2]);

  return (
    <section className="w-full bg-[#FAFAFA] dark:bg-black min-w-[320px] flex items-center justify-center px-4 sm:px-6 md:px-8 lg:px-10">
      <div className="relative z-20 w-full max-w-[1100px]">
        {/* Grid container with same height as hero section */}
        <div className="relative z-10 w-full h-[500px] sm:h-[550px] md:h-[600px] lg:h-[650px] border-t-2 border-b-2 border-[#EAEAEA] dark:border-[#1E1E1E] flex flex-col mx-auto">
          {/* Circle grid at the top - with responsive height */}
          <div className="h-[100px] sm:h-[120px] md:h-[150px] lg:h-[300px]">
            <CircleGrid />
          </div>

          {/* Top right plus sign */}
          <div className="absolute z-30 -top-[10px] -right-[9px] flex items-center justify-center">
            <Plus className="text-[#A8A8A8] dark:text-[#878787] scale-100 md:scale-130" />
          </div>

            <div ref={ref} className="h-full border-r-2 border-l-2 border-[#EAEAEA] dark:border-[#1E1E1E]">
              <div>
                <GoogleGeminiEffect
                  pathLengths={[
                    pathLengthFirst,
                    pathLengthSecond,
                    pathLengthThird,
                    pathLengthFourth,
                    pathLengthFifth,
                  ]}
                />
              </div>
            </div>
        </div>
      </div>
    </section>
  );
}
